module.exports = __webpack_public_path__ + "static/media/sync-setting-banner.d75e1fec.svg";